module.exports = __webpack_public_path__ + "static/media/Facebook.a11ad9f3.svg";